export const pickUpPointsColumns = (t: any) => [
    {
      key: "column1",
      name: t("nav.street"),
      fieldName: "street",
      minWidth: 50,
      maxWidth: 100,
      isResizable: true,
    },
    {
      key: "column2",
      name: t("nav.postalCode"),
      fieldName: "postalCode",
      minWidth: 30,
      maxWidth: 100,
      isResizable: true,
    },
    {
      key: "column3",
      name: t("nav.city"),
      fieldName: "city",
      minWidth: 50,
      maxWidth: 100,
      isResizable: true,
    },
    {
      key: "column4",
      name: t("nav.colDepartment"),
      fieldName: "departmentCity",
      minWidth: 50,
      maxWidth: 100,
      isResizable: true,
    },
    {
      key: "column7",
      name: t("nav.colPhone"),
      fieldName: "phone",
      minWidth: 50,
      maxWidth: 100,
      isResizable: true,
    },
    {
      key: "column5",
      name: "BDO",
      fieldName: "bdoNumber",
      minWidth: 50,
      maxWidth: 100,
      isResizable: true,
    },
    {
      key: "column6",
      name: t("clients.columns.orderTypes"),
      fieldName: "orderType",
      minWidth: 50,
      maxWidth: 100,
      isResizable: true,
      onRender: (item: any) => {
        const map: any = {
          "Kontener": t("orders.typeValues.container"),
          "Tonaż":    t("orders.typeValues.tonnage"),
          "Pojazd":   t("orders.typeValues.vehicle"),
        };
        return map[item.orderType] !== undefined ? map[item.orderType] : item.orderType;
      },
  },
  {
      key: "importedFromCuo",
      name: t("nav.source"),
      fieldName: "importedFromCuo",
      minWidth: 100,
      maxWidth: 150,
      isResizable: true,
  }
  ];

  export const pickUpPointsColumnsShort = (t: any) => [
    {
      key: "column1",
      name: t("nav.street"),
      fieldName: "street",
      minWidth: 50,
      maxWidth: 100,
      isResizable: true,
    },
    {
      key: "column2",
      name: t("nav.postalCode"),
      fieldName: "postalCode",
      minWidth: 30,
      maxWidth: 100,
      isResizable: true,
    },
    {
      key: "column3",
      name: t("nav.city"),
      fieldName: "city",
      minWidth: 50,
      maxWidth: 100,
      isResizable: true,
    },
    {
      key: "column7",
      name: t("nav.colPhone"),
      fieldName: "phone",
      minWidth: 50,
      maxWidth: 100,
      isResizable: true,
    },
    {
      key: "column4",
      name: "BDO",
      fieldName: "bdoNumber",
      minWidth: 50,
      maxWidth: 100,
      isResizable: true,
    },
    { key: "column5",
      name: t("clients.columns.orderTypes"),
      fieldName: "orderType",
      minWidth: 50,
      maxWidth: 100,
      isResizable: true,
      onRender: (item: any) => {
        const map: any = {
          "Kontener": t("orders.typeValues.container"),
          "Tonaż":    t("orders.typeValues.tonnage"),
          "Pojazd":   t("orders.typeValues.vehicle"),
        };
        return map[item.orderType] !== undefined ? map[item.orderType] : item.orderType;
      },
  }
  ];
  
  export const generatePickUpPoints = (pickUpPoints: Array<any>) => {
    const items: Array<any> = [];
  
    pickUpPoints.forEach((point: any) => {
      items.push({
        key: point.id,
        id: point.id,
        street: point.street,
        postalCode: point.postalCode,
        city: point.city,
        isDefault: point.isDefault,
        departmentId: point.departmentId,
        departmentCity: point.departmentCity,
        phone: point.phone,
        bdoNumber: point.bdoNumber,
        orderTypeId: point.orderTypeId,
        orderType: point.orderType,
        isActive: point.isActive,
        importedFromCuo: point.importedFromCuo ? "CUO" : "SODO",
        containerInactivityAlertDays: point.containerInactivityAlertDays
      })
    });
  
    return [...items];
  };